<div id="manageWidgetNav" #manageWidgetNav class="manage-widget" >
    <div class="menu">
        <div
            class="icon-left-right-expand"
            (click)="toggleNav()"
            [ngClass]="{'icon-left-expand': isNavExpanded, 'icon-right-expand': !isNavExpanded}"
            [title]="isNavExpanded ? 'Collapse' : 'Expand'"
        >
        </div>

        <button
            class="ghost-btn dashboard-btn"
            [hidden]="!isNavExpanded"
            (click)="returnToDashboard()"
            (transitionend)="onButtonTransitionEnd($event)"
        >
            <span class="icon-left-expand"></span>
            View
        </button>
    </div>

    @if (isNavExpanded) {
        <div class="create-find-area">
            <div class="block" (click)="createNewWidget()">
                <span class="icon-add-widgets2"></span>
                Create New
            </div>

            <div class="block" (click)="findWidget($event)">
                <span class="icon-find-widgets-2 icon-widget-finder"></span>
                Find A Widget
            </div>
        </div>
    }

    <div class="manage-content-area" [hidden]="!isNavExpanded">
        <app-named-query-selector
            #namedQuerySelector
            [namedQuery]="namedQuery"
            (namedQuerySelected)="onNamedQuerySelected($event)"
            [jumpedFrom]="'widgets'"
            [isReadOnly]="isReadOnly"
        >
        </app-named-query-selector>

        <div class="select-visz">
            <p class="text-label">Select A Visualization</p>

            <div class="dropdown-wrapper viz-wrapper" appMousedownOutside (mousedownOutside)="showWidgetList=false">
                <div class="text-right">
                    <cc-icon
                        class="add-visualization-icon"
                        title="Add Visualization"
                        [icon]="'plus-circle'"
                        [disabled]="isReadOnly"
                        [size]="'small'"
                        (iconClicked)="showWidgets()"
                    >
                    </cc-icon>
                </div>

                @if (!selectedWidgets.length) {
                    <hr>
                }

                @if (showWidgetList && supportedWidgets.length) {
                    <div class="dropdown viz-dropdown">
                        @for (widget of supportedWidgets; track widget.uid) {
                            <div>
                                @if (widget.isViz) {
                                    <ul class="vizforms">
                                        @for (config of widget.vizConfigs; track config.name) {
                                            <li (click)="toggleViz(config)">
                                                <span [ngClass]="config.cssClass">
                                                    @if (isStackedAreaChartVizType(config.visualizationType)) {
                                                        <ddv-stacked-area-chart-icon></ddv-stacked-area-chart-icon>
                                                    }
                                                </span>

                                                <label>{{ config.name }}</label>

                                                <cc-icon
                                                    [ngClass]="!config.selected ? 'select-visualization' : 'clear-visualization'"
                                                    [icon]="!config.selected ? 'plus-circle' : 'close'"
                                                    [size]="'xsmall'"
                                                    [hoverColor]="'var(--mw-viztype-active)'"
                                                    (iconClicked)="toggleViz(config)"
                                                >
                                                </cc-icon>
                                            </li>
                                        }
                                    </ul>
                                }

                                @if (!widget.isViz && widget.isConfigurable) {
                                    <div class="summary-widget" (click)="toggleWidget(widget)">
                                        <span [ngClass]="widget.cssClass"></span>

                                        <label>{{ widget.title }}</label>

                                        <cc-icon
                                            [ngClass]="!widget.selected ? 'select-visualization' : 'clear-visualization'"
                                            [icon]="!widget.selected ? 'plus-circle' : 'close'"
                                            [size]="'xsmall'"
                                            [hoverColor]="'var(--mw-viztype-active)'"
                                            (iconClicked)="toggleWidget(widget)"
                                        >
                                        </cc-icon>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
            </div>

            <div class="tab-details">
                @if (selectedWidgets.length) {
                    <div class="tabtype">
                        <app-visualization-nav-header
                            #visualizationNavTabHeader
                            [vizTabs]="selectedWidgets"
                            [isReadOnly]="isReadOnly"
                            (navTabFocus)="onNavTabFocus($event)"
                            (removeTab)="removeSelectedWidget($event)"
                            (dragDropEnd)="onDragDropSucceeded()"
                        >
                        </app-visualization-nav-header>

                        <div class="inner-tabs">
                            <div class="tabset">
                                <div class="tabset-nav-container">
                                    <ul class="nav nav-tabs">
                                        <li
                                            [ngClass]="{'active': selectedTab === 'configure'}"
                                            (click)="switchTab('configure')"
                                        >
                                            Configure
                                        </li>

                                        <li
                                            [ngClass]="{'active': selectedTab === 'format'}"
                                            (click)="switchTab('format')"
                                        >
                                            Format
                                        </li>

                                        @if (showColorTab) {
                                            <li
                                                [ngClass]="{'active': selectedTab === 'color'}"
                                                (click)="switchTab('color')"
                                            >
                                                Color
                                            </li>
                                        }
                                    </ul>

                                    @if (showAutoAddDynamicColumnsOption) {
                                        <div class="option-container">
                                            <cc-checkbox
                                                label="Auto Add Dynamic Columns"
                                                [(value)]="autoAddDynamicColumns"
                                                (valueChange)="onAutoAddDynamicColumnsChanged($event)"
                                            >
                                            </cc-checkbox>
                                        </div>
                                    }
                                </div>

                                <div class="tabset-content">
                                    <div
                                        class="tab-container"
                                        [ngClass]="{'active-tab' : selectedTab === 'configure', 'readonly': isReadOnly}"
                                    >
                                        <div #configureTabContainer></div>
                                    </div>

                                    <div
                                        class="tab-container"
                                        [ngClass]="{'active-tab' : selectedTab === 'format', 'readonly': isReadOnly}"
                                    >
                                        <div #formatTabContainer></div>
                                    </div>

                                    <div
                                        class="tab-container"
                                        [ngClass]="{'active-tab' : selectedTab === 'color', 'readonly': isReadOnly}">
                                        <div #colorTabContainer></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
